import { render, staticRenderFns } from "./ReservationMessages.vue?vue&type=template&id=0ae7c3bc&"
import script from "./ReservationMessages.vue?vue&type=script&lang=js&"
export * from "./ReservationMessages.vue?vue&type=script&lang=js&"
import style0 from "./ReservationMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports